'use strict';

var reactHookForm = require('react-hook-form');
var hooks_useCombinedRefs = require('../hooks/useCombinedRefs.js');
var reactHookForm_FormManagerProvider = require('./FormManagerProvider.js');
var getSchemaPathRequirementMap = require('../_chunks/getSchemaPathRequirementMap-DIM0tidl.js');
require('react');
require('react/jsx-runtime');

const isPathInSchemaRequired = (path, schemaPathRequirementMap) => {
    if (path in schemaPathRequirementMap) {
        return schemaPathRequirementMap[path];
    }
    const normalizedPath = path
        .split('.')
        .map((part) => (/^\d+$/.test(part) ? getSchemaPathRequirementMap.ARRAY_ITEM_WILDCARD : part))
        .join('.');
    if (normalizedPath in schemaPathRequirementMap) {
        return schemaPathRequirementMap[normalizedPath];
    }
    // if the path is still not found, it's possible that the schema contains a z.map() or a z.record()
    // subschema where any key is allowed. Those keys in the schemaPathRequirementMap are marked with a wildcard,
    // so we will try to iteratively replace parts in the path with the wildcard to see if we can find a match
    const pathParts = normalizedPath.split('.');
    let subpath = '';
    for (let i = 1; i < pathParts.length; i += 0) {
        // each possible subpath is included in the schemaPathRequirementMap, so we check if
        // either the current subpath or the subpath with a wildcard is included in the map
        const currentSubpath = getSchemaPathRequirementMap.joinPaths(subpath, pathParts[i]);
        if (currentSubpath in schemaPathRequirementMap) {
            subpath = currentSubpath;
            continue;
        }
        const wildcardSubpath = getSchemaPathRequirementMap.joinPaths(subpath, getSchemaPathRequirementMap.MAP_WILDCARD);
        if (wildcardSubpath in schemaPathRequirementMap) {
            subpath = wildcardSubpath;
            continue;
        }
        // could not find the next subpath in the schema, so we cannot continue
        if (process.env.NODE_ENV !== 'production') {
            console.error(`Could not determine if path "${path}" is required based on the the schema`);
        }
        return false;
    }
    return schemaPathRequirementMap[subpath];
};

const useManagedProps = ({ schemaPathRequirementMap: schemaPathRequirementMapProp, controlProps, ...props }, ref) => {
    // making TProps extend this type causes a lot of type issues as the props of the input components are not consistent enough
    // e.g in some cases the argument in onChange can be undefined, sometimes it can be null, other time it can only be a non-nullable value
    const { onChange, onBlur, required } = props;
    const { field, fieldState, formState } = reactHookForm.useController(controlProps);
    const { schemaPathRequirementMap: schemaPathRequirementMapFromContext } = reactHookForm_FormManagerProvider.useFormManager() ?? {};
    const combinedRefs = hooks_useCombinedRefs.useCombinedRefs(ref, field.ref);
    const schema = schemaPathRequirementMapProp ?? schemaPathRequirementMapFromContext;
    const { name, 
    // `name` is not necessary for React Hook Form to function and can cause issues with autocomplete, so we remove it from field before spreading it.
    ...fieldWithoutName } = field;
    return {
        propsWithRef: {
            status: fieldState.error ? 'error' : undefined,
            required: schema
                ? isPathInSchemaRequired(controlProps.name, schema)
                : required,
            ...props,
            ...fieldWithoutName,
            onChange: (value) => {
                field.onChange(value);
                onChange?.(value);
            },
            onBlur: (event) => {
                field.onBlur();
                onBlur?.(event);
            },
            ref: combinedRefs,
        },
        field,
        fieldState,
        formState,
    };
};

exports.useManagedProps = useManagedProps;
//# sourceMappingURL=useManagedProps.js.map
